import {useMutation} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {OrdersCreateSubjectElementType, OrdersCreateType} from "../interface";
import {createOrder} from "../../../../../api/order/OrdersApi";

export const useCreateOrder = () => {
    const {handleModal} = useModal();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: {
            orderDetailRes: OrdersCreateType,
            orderSubjectResList: OrdersCreateSubjectElementType[]
        }) => createOrder(data),
        onSuccess: () => {
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
